import { useState, useEffect } from "react";
import { useAppSelector } from "../../../app/hooks";
import PageLoader from "../../../components/PageLoader";
import { getAppConfig, updateAppConfig } from "../../../actions/authActions";

const SecuritySettingsForm = () => {
  const { user, appConfig } = useAppSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  // Initialize state with the provided values
  const [securitySettings, setSecuritySettings] = useState({
    notifyLoginActivity: true,
    enableTwoFactorAuthentication: true,
    securityMailBox: "",
    singleUserModeEnabled: true,
    enabledCustomApprovalFlow: false,
  });

  const getOptions = async () => {
    // @ts-ignore
    getAppConfig(user?.ISD, (resp) => {
      setSecuritySettings(resp.data);
      setLoading(false);
    });
  }

  useEffect(() => {
    // @ts-ignore
    if (!appConfig && user?.ISD) {
      getOptions();
    } else {
      // @ts-ignore
      setSecuritySettings(appConfig);
      setLoading(false);
    }
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Use the checked property for checkboxes, and value for other input types
    const inputValue = type === 'checkbox' ? checked : value;

    setSecuritySettings(prevState => ({
      ...prevState,
      [name]: inputValue
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // @ts-ignore
    updateAppConfig(securitySettings, user.ISD, (resp) => {
      getOptions();
    })
  };

  if (loading) {
    return <PageLoader />
  }

  return (
    <div className="w-full mx-auto my-4 bg-white p-6">

      <form onSubmit={handleSubmit}>
        {/* Notification settings */}
        <div className="mb-4">
          <label className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="notifyLoginActivity"
              checked={securitySettings.notifyLoginActivity}
              onChange={handleInputChange}
              className="h-5 w-5 text-az-teal accent-az-teal"
            />
            <span className="text-gray-700">Notify me about login activity</span>
          </label>
        </div>

        {/* Two-factor authentication */}
        <div className="mb-4">
          <label className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="enableTwoFactorAuthentication"
              checked={securitySettings.enableTwoFactorAuthentication}
              onChange={handleInputChange}
              className="h-5 w-5 text-az-teal accent-az-teal"
            />
            <span className="text-gray-700">Enable two-factor authentication</span>
          </label>
        </div>
        <div className="mb-6">
          <label className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="singleUserModeEnabled"
              checked={securitySettings.singleUserModeEnabled}
              onChange={handleInputChange}
              className="h-5 w-5 text-az-teal  accent-az-teal"
            />
            <span className="text-gray-700">Enable single user mode</span>
          </label>
          <p className="mt-1 ml-8 text-left text-sm text-gray-500 max-w-[300px]">
            If disabled, you would require atleast two other users on your account with roles; Uploader and Approver. Otherwise, a single user can complete everything.
          </p>
        </div>
        <div className="mb-6">
          <label className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="enabledCustomApprovalFlow"
              checked={securitySettings.enabledCustomApprovalFlow}
              onChange={handleInputChange}
              className="h-5 w-5 text-az-teal  accent-az-teal"
            />
            <span className="text-gray-700">Enable custom approval flow</span>
          </label>
          <p className="mt-1 ml-8 text-left text-sm text-gray-500 max-w-[300px]">
            If enabled, you would be able to create your custom approval flow.
          </p>
        </div>

        {/* Security email */}
        <div className="mb-4 items-start max-w-[300px] w-full">
          <label className="block text-gray-700 mb-2 text-left">Security Email</label>
          <input
            type="email"
            name="securityMailBox"
            value={securitySettings.securityMailBox}
            onChange={handleInputChange}
            placeholder="security@example.com"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-az-teal"
            required
          />
          <p className="mt-1 text-sm text-left text-gray-500">
            We'll send security alerts to this email address
          </p>
        </div>

        {/* Single user mode */}


        {/* Submit button */}
        <div className="flex justify-start">
          <button
            type="submit"
            className="px-4 py-2 bg-az-teal text-white rounded-md hover:bg-az-teal focus:outline-none focus:ring-2 focus:ring-az-teal focus:ring-offset-2"
          >
            Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default SecuritySettingsForm;